module.exports = __webpack_public_path__ + "static/img/章桂华名片PC.f65336c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/章桂华名片PC.jpg
// module id = 3Lp9
// module chunks = 1